import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button, Alert, Card } from 'antd';
import Ink from 'react-ink';

import './login.css';

import {
	userLogin
} from '../../modules/user';

import { MailOutlined, LockOutlined } from '@ant-design/icons';

const FormItem = Form.Item;

const LoginCard = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const userSessionTimeout = useSelector(state => state.user.userSessionTimeout);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (values) => {
    setLoading(true);
    setMessage(null);
    try {
      await dispatch(userLogin(values));
      setLoading(false);
      form.resetFields();
      if (!userSessionTimeout) {
        window.parent.location = window.parent.location.origin;
      }
    } catch (err) {
      setLoading(false);
      setMessage(err?.message || 'Please check Username/Password and try again.');
    }
  };

  return (
			<Card className="loginHolder">
				<h3 className="title"><LockOutlined /> Welcome to Deca VPP</h3>
				<Form form={form} name="myForm" onFinish={handleSubmit} className="login-form">
					<div className="contentHolder">
						{message ? <Alert message={message} type="error" style={{ marginBottom: '20px' }} showIcon /> : ""}
						<FormItem name='email' rules={[{ type: 'email', message: 'Please input a valid E-mail!' },
						{ required: true, message: 'Please input your username!' }]}>
							<Input className="loginInput" size="large" prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="E-mail" />
						</FormItem>
						<FormItem name='password' rules={[{ required: true, message: 'Please input your Password!' }]}>
							<Input className="loginInput" size="large" prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
						</FormItem>
					</div>
					<div className="btnHolder">
						{
							loading ?
								<Button size="large" htmlType="submit" disabled><Ink />Log in </Button>
								:
								<Button size="large" htmlType="submit"><Ink />Sign In </Button>
						}
					</div>
				</Form>
			</Card>
	);
}

export default LoginCard;
